/**
 * LocalFileDataManager.js
 * Talkroute
 *
 * Created by Vel Genov on 12/19/18
 * Copyright (c) 2018 Talkroute. All right reserved.
 */

import path from "path";

import appConfig from "../config/index";

/**
 * A simple data manager that stores and retrieves data from a local JSON file
 */
class LocalFileDataManager {
  public filePath: string;
  public data: any;

  constructor(opts) {
    // Bundle file
    this.filePath = path.join(__dirname, `${opts.configName}.json`);
    this.data = this.parseDataFile(opts.defaults);
  }

  /**
   * @param key key to use when retriaving data
   * @returns the data stored under the key
   */
  getDataForKey = (key) => {
    try {
      return this.data[key];
    } catch (error) {
    }
  };

  /**
   * Get the raw data loaded by the LocalFileDataManager
   *
   * @returns the raw data loaded by the LocalFileDataManager
   */
  getData = () => this.data;

  /**
   * @param key key to use when storing data
   * @param val any value to store under the key
   */
  setData = (key, val) => {
    this.data[key] = val;

    this.writeFileSync(this.data);
  };

  /** Create a new data file using the defaults or read a file if one exists
   * @param defaults Array of data to write
   * @returns the data
   */
  parseDataFile = (defaults) => {
    try {
      return JSON.parse(appConfig.fileStorage!!.get(this.filePath).toString());
    } catch (error) {
      if (defaults !== undefined) {
        this.writeFileSync(defaults);
      }
      return defaults;
    }
  };

  /**
   * A convenience function to write the data to a file and log any errors
   * @param data Array of data to write
   */
  writeFileSync = (data) => {
    // Using sync here, since this is local data and it will not be a performance hit
    // If we used an async API and our app was quit before the asynchronous write had a chance to complete,
    try {
      appConfig.fileStorage?.save(this.filePath, JSON.stringify(data));
    } catch (error) {
    }
  };
}

export default LocalFileDataManager;
